import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { DOMAINS_SEARCH_SUITE_TRANSLATIONS_NS, resourceLoader } from '../../../assets/resourceLoader';
export const DomainSearchSuiteTranslationsExtension = ModuleExtensions.translationsExtension(resourceLoader, {
  namespace: DOMAINS_SEARCH_SUITE_TRANSLATIONS_NS
});
//# sourceMappingURL=domainSearchSuiteTranalationsExtension.js.map